"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var tools_1 = require("../../../utils/tools");
var prosemirror_state_1 = require("prosemirror-state");
var typeset_1 = require("../../../utils/typeset");
var TypesetUtil = /** @class */ (function () {
    function TypesetUtil(editor, props) {
        var _this = this;
        this.name = '';
        this.attrName = '';
        this.constructValue = function (props) {
            var _a;
            if (!_this.attrName) {
                _this.attrName = _this.name.replace(/_(.)/, function ($0, $1) { return $1.toUpperCase(); });
            }
            var cValues = props.values;
            if (!cValues)
                return;
            _this.value = [];
            if (props.values) {
                _this.value = typeset_1.formatMenuValues(_this.attrName, props.values, (_a = {}, _a[_this.attrName] = '', _a));
            }
        };
        this.handler = function (editor, name, attrs) {
            editor.nodesBetween(function (node, nodePos) {
                if (node.isTextblock) {
                    editor.update(attrs, nodePos);
                    return false;
                }
                return true;
            });
            editor.focus();
        };
        this.disable = function (editor) {
            var selection = editor.view.state.selection;
            return !(selection instanceof prosemirror_state_1.AllSelection) && !tools_1.checkParentSupportAttr(editor.view, _this.attrName);
        };
        this.type = 'dropdown';
        this.getAttrs = function (editor) {
            var _a;
            var node = editor.view.state.selection.$from.node();
            var attr = node.attrs[_this.attrName];
            if (attr === '')
                return '';
            return _a = {}, _a[_this.attrName] = +attr, _a;
        };
        this.value = [];
        this.editor = editor;
    }
    return TypesetUtil;
}());
exports.TypesetUtil = TypesetUtil;
var SpaceBothUtil = /** @class */ (function (_super) {
    __extends(SpaceBothUtil, _super);
    function SpaceBothUtil(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = 'space_both';
        _this.constructValue(__assign({ values: [0, 4, 8] }, props));
        return _this;
    }
    return SpaceBothUtil;
}(TypesetUtil));
exports.SpaceBothUtil = SpaceBothUtil;
var SpaceAfterUtil = /** @class */ (function (_super) {
    __extends(SpaceAfterUtil, _super);
    function SpaceAfterUtil(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = 'space_after';
        _this.constructValue(__assign({ values: [0, 4, 8] }, props));
        return _this;
    }
    return SpaceAfterUtil;
}(TypesetUtil));
exports.SpaceAfterUtil = SpaceAfterUtil;
var SpaceBeforeUtil = /** @class */ (function (_super) {
    __extends(SpaceBeforeUtil, _super);
    function SpaceBeforeUtil(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = 'space_before';
        _this.constructValue(__assign({ values: [0, 4, 8] }, props));
        return _this;
    }
    return SpaceBeforeUtil;
}(TypesetUtil));
exports.SpaceBeforeUtil = SpaceBeforeUtil;
var LineHeightUtil = /** @class */ (function (_super) {
    __extends(LineHeightUtil, _super);
    function LineHeightUtil(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = 'line_height';
        _this.constructValue(__assign({ values: [1, 2, 3] }, props));
        return _this;
    }
    return LineHeightUtil;
}(TypesetUtil));
exports.LineHeightUtil = LineHeightUtil;
//# sourceMappingURL=typeset-util.js.map